import { ID_FTHB_40YR_FIXED_15YR_BALLOON_RATE } from "../../../utilities/validatorConstants";
import { LoanType, MortgageCategory } from "./constants";

export function getMortgageCategory (loan: string, loanType: LoanType, rateId: number): MortgageCategory | null {

    // Only these 3 types can be determined by the loanType
    if (loanType === LoanType.USDARuralHousing) return MortgageCategory.USDA;
    if (loanType === LoanType.VA) return MortgageCategory.VA;
    if (loanType === LoanType.FHA) return MortgageCategory.FHA;

    // Using loan name to figure out category
    const loanName = loan.toLowerCase();
    const isArm = loanName.includes("adjustable rate mortgage");
    const isFTHB = loanName.includes("first-time homebuyer");
    if (isArm && isFTHB) return MortgageCategory.FTHB_ARM;
    if (isArm) return MortgageCategory.ARM;
    if (isFTHB) return MortgageCategory.FTHB;
    if (loanName.includes("refinance")) return MortgageCategory.REFINANCE;
    if (loanName.includes("fixed mortgage")) return MortgageCategory.FIXED_MORTAGE;
    if (loanName.includes("construction")) return MortgageCategory.CONSTRUCTION;
    if (loanName.includes("lot loan")) return MortgageCategory.LOT;
    if (loanName.includes("jumbo")) return MortgageCategory.JUMBO;
    if (loanName.includes("second mortgage")) return MortgageCategory.SECOND_MORTGAGE;

    // Named "40-Year Fixed-Rate with 15-Year Balloon", better not to use name to get category
    if (ID_FTHB_40YR_FIXED_15YR_BALLOON_RATE === rateId) {
        return MortgageCategory.FTHB;
    }
    return null;
}